import { persist } from '@/assets/js/util.js'
import { client } from '@/assets/js/pocketbase.js'
import tenant from '@/store/tenant.js'
import { get } from 'svelte/store'

const data = {
    enabled: false
}

const context = persist('sosMode', data)

let unsubscribe = null
let subscribedTenantId = null

export function applySosModeFromTenantRecord(record) {
    if (!record) return
    context.commit('enabled', !!record.sos_mode)
}

export async function syncSosModeFromTenant() {
    const id = get(tenant).id
    if (!id) return
    try {
        const record = await client.collection('tenants').getOne(id)
        applySosModeFromTenantRecord(record)
    } catch (e) {
        console.error('Failed to sync SOS mode', e)
    }
}

export async function saveSosMode(enabled) {
    context.commit('enabled', !!enabled)
    const id = get(tenant).id
    if (!id) return
    try {
        await client.collection('tenants').update(id, { sos_mode: !!enabled })
    } catch (e) {
        console.error('Failed to save SOS mode', e)
    }
}

export async function startSosModeSubscription(tenantId) {
    if (!tenantId) return
    if (subscribedTenantId === tenantId && unsubscribe) return
    await stopSosModeSubscription()
    try {
        subscribedTenantId = tenantId
        unsubscribe = await client.collection('tenants').subscribe(tenantId, (e) => {
            applySosModeFromTenantRecord(e.record)
        })
    } catch (e) {
        subscribedTenantId = null
        console.error('SOS mode subscription failed', e)
    }
}

export async function stopSosModeSubscription() {
    if (unsubscribe) {
        await unsubscribe()
        unsubscribe = null
    }
    subscribedTenantId = null
}

export default context
